import { useState } from 'react';

export default class ModalInstance<TOptions, TResult = string> {
  private setOptionsCallback?: (options?: TOptions) => void;
  private onCloseCallback?: (result: TResult) => void;

  constructor(private readonly name: string) {
    this.show = this.show.bind(this);
    this.close = this.close.bind(this);
    this.useOptions = this.useOptions.bind(this);
  }

  async show(options: TOptions = {} as any): Promise<TResult> {
    return new Promise((resolve) => {
      this.onCloseCallback = resolve;

      if (typeof this.setOptionsCallback === 'function') {
        this.setOptionsCallback(options);
      } else {
        console.warn(`${this.name}: show() called, but component not rendered`);
      }
    });
  }

  close(result: TResult = 'cancel' as any) {
    if (typeof this.setOptionsCallback === 'function') {
      this.setOptionsCallback(undefined);
    } else {
      console.warn(`${this.name}: close() called, but component not rendered`);
    }

    if (typeof this.onCloseCallback === 'function') {
      this.onCloseCallback(result);
    } else {
      console.warn(`${this.name}: close() called, but onClose is not set`);
    }
  }

  /**
   * Instance-base hook which allows loading options inside a Modal component.
   *
   * Warning, as a usual hook, it should be called from a function component only
   */
  useOptions(): [TOptions | undefined, (options: TOptions) => void] {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [options, setOptions] = useState<TOptions>();
    this.setOptionsCallback = setOptions;
    return [options, setOptions];
  }
}
